const shoppingCartModalReducer = (state = false, action) => {
    switch(action.type) {
        case 'SET_SHOPPING_CART_MODAL':
            return !state;
        default:
            return state;
    }
}

export default shoppingCartModalReducer;